module.exports = __webpack_public_path__ + "static/media/DS-CMS-Import-pt.598181f0.xlsx";